import { InjectionToken } from '@angular/core';
import { StoragePort } from '@platform/storage/domain/ports/storage.port';
import { ServiceState } from '@features/service/application/stores/service.store';

export const SERVICE_STORE_STORAGE = new InjectionToken<StoragePort<ServiceState>>('SERVICE_STORE_STORAGE');
